import React from "react";
import {
  Avatar,
  Box,
  Button,
  Hidden,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import { Version } from "./apps-types";
import { useTranslation } from "react-i18next";
import LinkGenerationDesktop from "./LinkGeneration";
import UploadingAppForm from "./UploadingApplication";
import { Android, Apple, Smartphone } from "@mui/icons-material";

/* ApplicationDetailsPage top component, showing app icon, name, platform and description.
This part is differently shown according to the device screen size. */
export default function AppIntro(props: {
  appID: number;
  description: string;
  platform: string;
  appName: string;
  versions: Version[];
  setVersions?: any;
  openLinkGeneration: boolean;
  setOpenLinkGeneration: any;
}) {
  const [openUploadDialog, setOpenUploadDialog] = React.useState(false);
  const { t } = useTranslation();
  return (
    <Box>
      <UploadingAppForm
        buttonText={t("New Version")}
        dialogTitle={t("Load a New Version")}
        expectedAppID={props.appID}
        isDashboard={false}
        openDialog={openUploadDialog}
        updateOpenUploadDialog={setOpenUploadDialog}
        versions={props.versions}
      />
      <Hidden mdDown>
        <Stack direction="column">
          <Stack direction="row" justifyContent="space-between">
            <Stack direction="row" spacing={2}>
              <Avatar
                alt="app-icon"
                src={`${process.env.REACT_APP_BACKEND_BASE_URL}apps/${props.appID}/icon`}
                sx={{ width: 150, height: 150 }}
              />
              <Stack direction="column">
                <Stack direction="row" spacing={2}>
                  <Typography variant="h2">{props.appName}</Typography>
                  <Stack direction="row" spacing={1}>
                    {(props.platform === "Android; iOS;" ||
                      props.platform === "iOS") && (
                      <Apple color="action" sx={{ width: 35, height: 35 }} />
                    )}
                    {(props.platform === "Android; iOS;" ||
                      props.platform === "Android") && (
                      <Android color="action" sx={{ width: 35, height: 35 }} />
                    )}
                  </Stack>
                </Stack>
                <Typography variant="h5">{props.description}</Typography>
              </Stack>
            </Stack>
            <Stack
              spacing={2}
              direction="row"
              justifyContent="end"
              marginBottom={5}
            >
              <Box>
                <Button
                  variant="contained"
                  onClick={() => setOpenUploadDialog(true)}
                  startIcon={<Smartphone />}
                >
                  {t("New Version")}
                </Button>
              </Box>
              <LinkGenerationDesktop
                name={props.appName}
                versions={props.versions}
                platform={props.platform}
              />
            </Stack>
          </Stack>
        </Stack>
      </Hidden>
      <Hidden mdUp>
        <Grid container spacing={1} alignItems="center" justifyContent="center">
          <Grid item xs={12}>
            <Box display="flex" alignItems="center" justifyContent="center">
              <Avatar
                alt="app-icon"
                src={`${process.env.REACT_APP_BACKEND_BASE_URL}apps/${props.appID}/icon`}
                sx={{ width: 50, height: 50 }}
              />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Stack direction="column">
              <Typography variant="h2" textAlign="center">
                {props.appName}
              </Typography>
              <Typography variant="h5" textAlign="center">
                {props.description}
              </Typography>
              <Box display="flex" alignItems="center" justifyContent="center">
                {(props.platform === "Android; iOS;" ||
                  props.platform === "iOS") && (
                  <Apple color="action" sx={{ width: 35, height: 35 }} />
                )}
                {(props.platform === "Android; iOS;" ||
                  props.platform === "Android") && (
                  <Android color="action" sx={{ width: 35, height: 20 }} />
                )}
              </Box>
            </Stack>
          </Grid>
          <Grid item xs={12}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              sx={{ width: "100%" }}
            >
              <Box>
                <Button
                  variant="contained"
                  onClick={() => setOpenUploadDialog(true)}
                  startIcon={<Smartphone />}
                >
                  {t("New Version")}
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Hidden>
    </Box>
  );
}
